import { Component, inject } from '@angular/core';
import { AuthService } from '@isophi/core-legacy';
import { TranslocoService } from '@jsverse/transloco';

import { HelperService } from '../../../../core/services/helper.service';

enum FormTabsEnum {
  WORKPLACE,
  ORGANISATION,
  TRAFFIC,
}

@Component({
  selector: 'app-kindergarten-data',
  templateUrl: './kindergarten-data.component.html',
  styleUrls: ['./kindergarten-data.component.scss'],
  standalone: false,
})
export class KindergartenDataComponent {
  tabs: typeof FormTabsEnum = FormTabsEnum;

  protected authService = inject(AuthService);

  private _selectedTab: FormTabsEnum = FormTabsEnum.WORKPLACE;

  get selectedTab(): FormTabsEnum {
    return this._selectedTab;
  }

  constructor(private helperService: HelperService, private translocoService: TranslocoService) {
    this.helperService.setTitle(null, this.translocoService.translate('settings/kindergartenData'));
  }

  /**
   * Activate action type and form by user select (MANUAL/by_code).
   *
   * @param actionType
   * @param event
   */
  selectTab(selectedTab: FormTabsEnum, event: MouseEvent): void {
    event.preventDefault();
    this._selectedTab = selectedTab;
  }
}
